/* unplugin-vue-components disabled */import script from "./MacthList.vue?vue&type=script&setup=true&lang=js"
export * from "./MacthList.vue?vue&type=script&setup=true&lang=js"

import "./MacthList.vue?vue&type=style&index=0&id=622fa480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622fa480"]])

export default __exports__